const dateFormats: Record<string, string> = {
  "en-US": "MM/dd/yyyy",
  "sr-Latn": "dd.MM.yyyy.",
};

const dateTimeFormats: Record<string, string> = {
  "en-US": "MM/dd/yyyy hh:mm",
  "sr-Latn": "dd.MM.yyyy. HH:mm",
};

const dateTimeSecondsFormats: Record<string, string> = {
  "en-US": "MM/dd/yyyy hh:mm:ss",
  "sr-Latn": "dd.MM.yyyy HH:mm:ss",
};

export const formats = {
  dateFormats,
  dateTimeFormats,
  dateTimeSecondsFormats,
};
